export enum ROLES {
  Admin = "admin",
  Staff = "staff",
  Client = "client",
  Collaborator = "collaborator",
  GlobalPartner = "gpn",
}
